import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { useThemeStore } from "./store/theme";
import "./styles/index.css";

const applyTheme = () => {
  const mode = useThemeStore.getState().mode;
  const sys = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const dark = mode === "dark" || (mode === "system" && sys);
  document.documentElement.classList.toggle("dark", dark);
};
applyTheme();
useThemeStore.subscribe(applyTheme);

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000 } } });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
